// src/context/AuthContext.js
import React, { createContext, useState, useEffect, useContext } from 'react';
import axios from '../api/axios';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [authState, setAuthState] = useState({
    isAuthenticated: false,
    isSuperUser: false,
    user: null,
    authChecked: false,
  });

  // Check authentication status on app start or refresh
  const checkAuth = async () => {
    const token = localStorage.getItem('access_token');
    if (!token) {
      setAuthState({
        isAuthenticated: false,
        isSuperUser: false,
        user: null,
        authChecked: true,
      });
      return;
    }

    try {
      const res = await axios.get('/api/check-auth/', {
        headers: { Authorization: `Token ${token}` },
      });

      setAuthState({
        isAuthenticated: res.data.is_authenticated,
        isSuperUser: res.data.is_superuser,
        user: res.data.user || null,
        authChecked: true,
      });
    } catch (err) {
      console.error('Auth check error:', err);
      setAuthState({
        isAuthenticated: false,
        isSuperUser: false,
        user: null,
        authChecked: true,
      });
    }
  };

  // Login function to authenticate user and get token
  const login = async (username, password) => {
    try {
      const response = await axios.post(
        '/api/login/',
        { username, password },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.status === 200) {
        const { token } = response.data;
        localStorage.setItem('access_token', token);

        await checkAuth();
        return true;
      }
    } catch (error) {
      console.error('Login failed:', error.response?.data || error.message);
      setAuthState((prev) => ({ ...prev, authChecked: true }));
      return false;
    }
  };

  const logout = () => {
    localStorage.removeItem('access_token');
    setAuthState({
      isAuthenticated: false,
      isSuperUser: false,
      user: null,
      authChecked: true,
    });
  };

  useEffect(() => {
    checkAuth();
  }, []);

  return (
    <AuthContext.Provider value={{ ...authState, checkAuth, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);